import React from "react";
import {Spinner, Text} from "react-vcomponents";
import {O, RunInAction, RunInAction_Set} from "web-vcore";
import {store} from "../../../../../Store/index.js";
import {GetOpenMapID} from "../../../../../Store/main/maps.js";
import {GetMapState} from "../../../../../Store/main/maps/$mapState.js";
import {observer_mgl_r3} from "../../../../../Utils/ThreeJS/General.js";
import {MapTool, Tool, ToolData} from "./@Tool.js";
import {observer_mgl} from "mobx-graphlink";

export class ToolState_Cursor {
	@O accessor roundTo_x = 1;
	@O accessor roundTo_y = 1;
}

export class Tool_Cursor extends Tool {
	toolType = MapTool.cursor;
	get ToolState() { return store.main.maps.tools.toolStates.cursor; }

	RenderInToolbox = observer_mgl(({data}: {data: ToolData.RenderInToolbox})=>{
		const {mapState} = data;
		const state = this.ToolState;
		return (
			<>
				<Text>Cursor, x:</Text>
				<Spinner ml={5} step="any" min={Number.MIN_SAFE_INTEGER} value={mapState.cursorPos.x} onChange={val=>RunInAction_Set(()=>mapState.cursorPos = mapState.cursorPos.NewX(val))}/>
				<Text ml={5}>Y:</Text>
				<Spinner ml={5} step="any" min={Number.MIN_SAFE_INTEGER} value={mapState.cursorPos.y} onChange={val=>RunInAction_Set(()=>mapState.cursorPos = mapState.cursorPos.NewY(val))}/>
				<Text ml={10}>Round to, x:</Text>
				<Spinner ml={5} min={0} step={.5} value={state.roundTo_x} onChange={val=>RunInAction_Set(()=>state.roundTo_x = val)}/>
				<Text ml={5}>Y:</Text>
				<Spinner ml={5} min={0} step={.5} value={state.roundTo_y} onChange={val=>RunInAction_Set(()=>state.roundTo_y = val)}/>
			</>
		);
	});

	Scene_OnPointerClick(data: ToolData.Scene_OnPointerClick) {
		if (data.event.button != 0) return; // left mouse-button only
		const mapID = GetOpenMapID.CatchBail(null);
		const mapState = GetMapState.CatchBail(null, mapID);
		if (mapState == null) return;
		const newCursorPos = data.mousePos_world;
		if (this.ToolState.roundTo_x > 0) newCursorPos.x = newCursorPos.x.RoundTo(this.ToolState.roundTo_x);
		if (this.ToolState.roundTo_y > 0) newCursorPos.y = newCursorPos.y.RoundTo(this.ToolState.roundTo_y);
		RunInAction("Tool_Cursor.Scene_OnPointerClick", ()=>mapState.cursorPos = newCursorPos);
	}
}